import styled from "styled-components";
import { baseColors } from "../../themes/definitions/si/cis/base-colors";
import { LobbyWrapperWithoutBackgroundDefaultBox } from "./lobby-wrapper.default.box";

export const LobbyWrapperSiCisBox = styled(LobbyWrapperWithoutBackgroundDefaultBox)`
    background-color: ${baseColors.base07};
`;